import React, { useState,  Suspense } from 'react';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import { mockData } from './mockData';
import { MdDashboard, MdLocalShipping, MdPeople, MdFolder, MdSettings, MdDescription } from 'react-icons/md';
import LoadingSpinner from './components/otherComponents/LoadingSpinner';
import MobileHamburgerNav from './MobileHamburgerNav';

// Lazy loading componente
const Dashboard = React.lazy(() => import('./components/Dashboard'));
const Transports = React.lazy(() => import('./components/Transports'));
const Clients = React.lazy(() => import('./components/Clients'));
const Management = React.lazy(() => import('./components/Management'));
const Settings = React.lazy(() => import('./components/Settings'));
const CMRManagement = React.lazy(() => import('./components/CMR'));
import AllMap from './components/location/AllMap';
import AllTransfersPage from './components/TransportPrincipalComponents/AllTransfersPage';

function AdminDashboard() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('all');

  const { stats = [], recentTransports = [], clients = [] } = mockData;

  const renderContent = () => {
    return (
      <Suspense fallback={<LoadingSpinner/>}>
        {(() => {
          switch (activeTab) {
            case 'dashboard':
              return <Dashboard stats={stats} recentTransports={recentTransports} />;
            case 'transports':
              return (
                <Transports
                  data={recentTransports}
                  searchTerm={searchTerm}
                  filter={selectedFilter}
                  onSearchChange={setSearchTerm}
                  onFilterChange={setSelectedFilter}
                />
              );
            case 'clients':
              return <Clients data={clients} />;
            case 'management':
              return <Management />;
            case 'settings':
              return <Settings />;
              case 'vehicule':
                return <AllMap/>;
              case 'transferuri':
                return <AllTransfersPage  />;
            case 'cmr':
              return <CMRManagement />;
            default:
              return <Dashboard stats={stats} recentTransports={recentTransports} />;
          }
        })()}
      </Suspense>
    );
  };

  return (
    <div className="h-screen w-screen overflow-hidden flex bg-gray-100">
      {/* Sidebar Desktop - cu dimensiuni fixe */}
      <div className="hidden md:flex md:w-64 md:flex-shrink-0 pb-16">
        <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
      </div>

      {/* Main Content Area */}
      <div className="flex flex-col flex-1 ">
        {/* Header */}
        <div className="flex-shrink-0">
          <Header activeTab={activeTab} />
          <MobileHamburgerNav activeTab={activeTab} setActiveTab={setActiveTab} />
        </div>

        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-auto bg-gray-50">
          <div className="p-4 sm:p-6 md:p-8 pb-20 md:pb-8">
            {renderContent()}
          </div>
        </div>
      </div>

     
    </div>
  );
}

export default AdminDashboard;